  
<h2 mat-dialog-title>Rename this Draft</h2>

<mat-dialog-content>


    <mat-form-field appearance="fill">
    <mat-label>Draft Name</mat-label>



    <input matInput (input)="change($event)" [placeholder]=gen_name [(ngModel)]="ud_name">
    <mat-hint>changes will be automatically saved</mat-hint>
    </mat-form-field>
    

    </mat-dialog-content>



  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>